import { Grid } from '@mui/material';
import { styled } from '@mui/system';

export const LoadingIndicatorMainGrid = styled(Grid)(() => ({
  border: '2px solid #ccc',
  borderRadius: '5px',
  width: '100%',
  minHeight: '72px',
}));
